import { useEffect } from 'react';

const useEnterKeySubmit = (onSubmit, deps = []) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        if (document.activeElement.tagName !== 'TEXTAREA') {
          e.preventDefault();
          onSubmit();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onSubmit, ...deps]);
};

export default useEnterKeySubmit;